import { 
  Component,
  ElementRef,
  Input,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  signal,
  WritableSignal } from '@angular/core';
  import { CommonModule } from '@angular/common';
  import { marked } from 'marked';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

type ChatMessageRaw = {
  question: string;
  answer: string;
};

type ChatMessage = {
  question: SafeHtml;
  answer: SafeHtml;
}

@Component({
  selector: 'app-chat-viewer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-viewer.component.html',
  styleUrl: './chat-viewer.component.scss'
})
export class ChatViewerComponent implements AfterViewInit, OnDestroy {
  @Input() chatData!: any;
  @Input() chatId!: string;
  @Input() chatHighlight!: string;
  @Input() citationType!: string;
  @Input() citationVariable!: string;
  @Input() citationTitle!: string;
  @Input() citationPromptNumber!: number;
  @Input() citationFullChat!: boolean;
  chatMessages:WritableSignal<ChatMessage[]> = signal([])
  VariableParsedData: WritableSignal<string> = signal("")
  title: WritableSignal<string> = signal("")

  constructor(private sanitizer: DomSanitizer) {
  }

  ngAfterViewInit() {
    if(this.citationType == 'chat_history') {
      this.loadChat(this.chatData, this.chatId)
      let fullchat = this.citationFullChat ? "" : ": Output selected"
      this.title.set(`Prompt ${this.citationPromptNumber} - ${this.citationTitle} ${fullchat}`)
      // this.title.set("Chat Input: " + this.citationTitle)
    }
    // if(this.citationType == 'variable_input') {
    //   let parsedData = JSON.parse(this.citationVariable)
    //   if(parsedData) {
    //     let transParsedData = parsedData.trim().replaceAll('\n', " ")
    //     const highlightText = this.chatHighlight?.trim();
    //     // let transParsedData = this.highlightClosestMatch(parsedData.trim().replaceAll('\n', " "), highlightText)
        

    //     const escapedHighlightStr = this.escapeRegExp(highlightText);
    //     const regex = new RegExp(escapedHighlightStr, 'gi');
    //     let highlightStr = transParsedData.replace(regex, (match: any) => `<div class="chat-highlight">${match}</div>`);
    //     this.VariableParsedData.set(highlightStr)
    //   }
    //   this.title.set("Variable Input: " + this.citationTitle)
    // }
    if(this.citationType == 'variable_input') {
      let parsedData = JSON.parse(this.citationVariable)
      if(parsedData) {
        let transParsedData = parsedData.trim().replaceAll('\n', " ")
        const highlightText = this.chatHighlight?.trim();
        // let transParsedData = this.highlightClosestMatch(parsedData.trim().replaceAll('\n', " "), highlightText)
        

        // const escapedHighlightStr = this.escapeRegExp(highlightText);
        // const regex = new RegExp(escapedHighlightStr, 'gi');
        // let highlightStr = transParsedData.replace(regex, (match: any) => `<div class="chat-highlight">${match}</div>`);
        let highlightStr = this.highlightMatches(transParsedData, highlightText)
        this.VariableParsedData.set(highlightStr)
      }
      this.title.set("Variable Input: " + this.citationTitle)
    }
    
 
  }

  highlightMatches(masterString: string, highlightText: string) {
    const normalizedMaster = this.normalizeString(masterString);
    const normalizedHighlight = this.normalizeString(highlightText);

    const escapedHighlight = this.escapeRegExp(normalizedHighlight);
    const regex = new RegExp(escapedHighlight, 'gi');

    return normalizedMaster.replace(regex, (match) => `<span class="chat-highlight">${match}</span>`);

  }
  // highlightMatches(masterString: string, highlightText: string) {
  //   // const parts = highlightText.split(/,|\./).map(p => p.trim()).filter(p => p);
  //   const parts = highlightText.split(/\n\s*\n|(?<=\.)|(?<=\,)\s+/).map(p => p.trim()).filter(p => p);

  //   let result = masterString;

  //   for (const part of parts) {
  //       const escapedPart = this.escapeRegExp(part);
  //       const regex = new RegExp(escapedPart, 'gi');

  //       result = result.replace(regex, (match) => `<span class="chat-highlight">${match}</span>`);
  //   }

  //   return result;
  // }

  normalizeString(str: string) {
    return str
        .replace(/[^a-zA-Z0-9\s]/g, '')  // remove all special characters
        .replace(/\s+/g, ' ')            // collapse multiple spaces
        .trim()
        .toLowerCase();                  // optional: make lowercase
  }


  async loadChat(chat: any, chatId: string) {
    let currChatMsg: ChatMessage[] = [];
    const highlightText = this.chatHighlight?.trim();

    chat.forEach((chatItem: any) => {

      let questionMd = chatItem.question;
      let answerMd = chatItem.answer;


      // Highlight logic
      if (highlightText) {
        questionMd = questionMd ? this.highlightChatMatches(questionMd, highlightText) : "";
        answerMd = answerMd ? this.highlightChatMatches(answerMd, highlightText) : "";
        // questionMd = questionMd ? this.highlightClosestMatch(questionMd, highlightText) : "";
        // answerMd = answerMd ? this.highlightClosestMatch(answerMd, highlightText) : "";
      }

      let rawHtmlQuestion = questionMd && marked.parse(questionMd).toString().replace(/\[\^\d+\^\]/g, '');
      let rawHtmlAnswer = answerMd && marked.parse(answerMd).toString().replace(/\[\^\d+\^\]/g, '');

      let safeMsgQuestion = rawHtmlQuestion ? this.sanitizer.bypassSecurityTrustHtml(rawHtmlQuestion) : "";
      let safeMsgAnswer = rawHtmlAnswer ? this.sanitizer.bypassSecurityTrustHtml(rawHtmlAnswer) : "";
      currChatMsg.push({question: safeMsgQuestion, answer: safeMsgAnswer})
    })
    this.chatMessages.set(currChatMsg);


    setTimeout(() => {
      const el = document.querySelector('.chat-highlight');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

  highlightChatMatches(masterString: string, highlightText: string): string {
    masterString = masterString.replace(/\[\^\d+\^\]/g, '');
    const normalizedHighlight = this.normalizeString(highlightText);
    const highlightLength = normalizedHighlight.length;
  
    let normalized = '';
    const map: number[] = [];
  
    for (let i = 0; i < masterString.length; i++) {
      const c = masterString[i];
  
      if (/\s/.test(c)) {
        if (normalized.at(-1) !== ' ') {
          normalized += ' ';
          map.push(i);
        }
      } else if (/[a-zA-Z0-9]/.test(c)) {
        normalized += c.toLowerCase();
        map.push(i);
      }
    }
  
    // Fuzzy match: check for 90% similarity in sliding window
    let bestMatch = { index: -1, score: 0 };
  
    for (let i = 0; i <= normalized.length - highlightLength; i++) {
      const window = normalized.slice(i, i + highlightLength);
  
      // Calculate overlap score
      const matchCount = window.split('').filter((c, j) => c === normalizedHighlight[j]).length;
      const similarity = matchCount / highlightLength;
  
      if (similarity >= 0.7 && similarity > bestMatch.score) {
        bestMatch = { index: i, score: similarity };
      }
    }
  
    if (bestMatch.index === -1) return masterString;
  
    const start = map[bestMatch.index];
    const end = map[bestMatch.index + highlightLength - 1] + 1;
  
    // return (
    //   masterString.slice(0, start) +
    //   `<span class="chat-highlight">` +
    //   masterString.slice(start, end) +
    //   `</span>` +
    //   masterString.slice(end)
    // );

    const rawHighlight = masterString.slice(start, end);

    // Split by "." and ":" but keep the delimiter using lookahead/lookbehind
    const segments = rawHighlight.split(/(?<=[*.:-])/);
    // const segments = rawHighlight.split(/(?<=[.:\-])|\*\*/);

    // Wrap each segment in a separate span
    const wrappedSegments = segments.map(segment => {
      return `<span class="chat-highlight">${segment}</span>`;
    }).join('');

    return (
      masterString.slice(0, start) +
      wrappedSegments +
      masterString.slice(end)
    );
  }
  
  


  // async loadChat(chat: any, chatId: string) {
  //   let currChatMsg: ChatMessage[] = [];
  //   const highlightText = this.chatHighlight?.trim();

  //   chat.forEach((chatItem: any) => {

  //     let questionMd = chatItem.question;
  //     let answerMd = chatItem.answer;


  //     // Highlight logic
  //     if (highlightText) {
  //       questionMd = questionMd ? this.highlightClosestMatch(questionMd, highlightText) : "";
  //       answerMd = answerMd ? this.highlightClosestMatch(answerMd, highlightText) : "";
  //     }

  //     let rawHtmlQuestion = questionMd && marked.parse(questionMd).toString().replace(/\[\^\d+\^\]/g, '');
  //     let rawHtmlAnswer = answerMd && marked.parse(answerMd).toString().replace(/\[\^\d+\^\]/g, '');

  //     let safeMsgQuestion = rawHtmlQuestion ? this.sanitizer.bypassSecurityTrustHtml(rawHtmlQuestion) : "";
  //     let safeMsgAnswer = rawHtmlAnswer ? this.sanitizer.bypassSecurityTrustHtml(rawHtmlAnswer) : "";
  //     currChatMsg.push({question: safeMsgQuestion, answer: safeMsgAnswer})
  //   })
  //   this.chatMessages.set(currChatMsg);


  //   setTimeout(() => {
  //     const el = document.querySelector('.chat-highlight');
  //     if (el) {
  //       el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //     }
  //   }, 100);
  // }

  // highlightClosestMatch(masterString: string, highlightString: string) {
  //   // Normalize spacing and punctuation
  //   const normalize = (str: string) =>
  //     str.replace(/\s+/g, ' ')
  //        .replace(/[–—-]/g, '-') // normalize dashes
  //        .trim()
  //        .toLowerCase();
  
  //   const normalizedHighlight = normalize(highlightString);
  
  //   // Split master string into logical sections (by double line breaks or poster blocks)
  //   const sections = masterString.split(/\n\s*\n|\d+\.\s+\*\*/);
  
  //   let bestMatch = '';
  //   let highestScore = 0;
  
  //   sections.forEach(section => {
  //     const normalizedSection = normalize(section);
  //     const score = this.similarityScore(normalizedSection, normalizedHighlight);
  
  //     if (score > highestScore) {
  //       highestScore = score;
  //       bestMatch = section;
  //     }
  //   });
  
  //   if (highestScore > 0.6) { // set threshold
  //     const escapedBestMatch = bestMatch.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  //     const regex = new RegExp(escapedBestMatch, 'g');
  //     // return masterString.replace(regex, `[[[${bestMatch}]]]`);
  //     // return masterString.replace(regex, `<div class="chat-highlight">${bestMatch}</div>`);
  //     return masterString.replace(regex, bestMatch.split('\n').map(item => `<div class="chat-highlight">${item}</div>`).join().replaceAll(",", ""));
  //   } else {
  //     return masterString;
  //   }
  // }
  
  // Basic similarity score (Jaccard index or word overlap)
  // similarityScore(a: any, b: any) {
  //   const aWords = new Set(a.split(/\s+/));
  //   const bWords = new Set(b.split(/\s+/));
  //   const intersection = new Set([...aWords].filter(word => bWords.has(word)));
  //   return intersection.size / Math.max(aWords.size, bWords.size);
  // }

  //Previous version...
  // highlightClosestMatch(masterString: string, highlightString: string) {

  //   // Normalize all quotes and apostrophes
  //   const normalizeQuotesAndApostrophes = (str: string) =>
  //     str
  //       .replace(/[\u2018\u2019]/g, "'")   // curly apostrophes to straight
  //       .replace(/['"]/g, "'");            // then unify to double quotes

  //   const normalize = (str: string) =>
  //     normalizeQuotesAndApostrophes(str)
  //       .replace(/\s+/g, ' ')
  //       .trim()
  //       .toLowerCase();
  
  //   const normalizedMaster = normalize(masterString);
  //   const normalizedHighlight = normalize(highlightString);

  //     const sections = normalizedMaster.split(/\. /);
  
  //     let bestMatch = '';
  //     let highestScore = 0;
    
  //     sections.forEach(section => {
  //       const score = this.similarityScore(section, normalizedHighlight);
    
  //       if (score > highestScore) {
  //         highestScore = score;
  //         bestMatch = section;
  //       }
  //     });
    
  //     if (highestScore > 0.6) { // set threshold
  //       // const escapedBestMatch = bestMatch.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  //       // const regex = new RegExp(escapedBestMatch, 'g');
  //       // return masterString.replace(regex, `[[[${bestMatch}]]]`);
  //       // return masterString.replace(regex, `<div class="chat-highlight">${bestMatch}</div>`);
  //       // return masterString.replace(regex, bestMatch.split('\n').map(item => `<div class="chat-highlight">${item}</div>`).join().replaceAll(",", ""));
        
  //       const escaped = bestMatch
  //       .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')     // escape regex chars
  //       .replace(/\s+/g, '\\s+');                     // allow loose spacing

  //       const regex = new RegExp(escaped, 'i');
      
  //       // return masterString.replace(regex, bestMatch.split('\n').map(item => `<div class="chat-highlight">${item}</div>`).join().replaceAll(",", ""));
  //       return masterString.replace(regex, (match) =>
  //         `<div class="chat-highlight">${match}</div>`
  //       );
  //     } else {
  //       return masterString;
  //     }
  
  //   // // Check if highlight exists in normalized form
  //   // const startIndex = normalizedMaster.indexOf(normalizedHighlight);
  //   // if (startIndex !== -1) {
      
  //   //   // Create regex to highlight in original masterString
  //   //   const rawMatchPattern = normalizeQuotesAndApostrophes(highlightString)
  //   //   .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
  //   //   .replace(/\s+/g, '\\s+');

  //   //   const regex = new RegExp(rawMatchPattern, 'i');
  //   //   return masterString.replace(/['"]/g, "'").replace(regex, (match) => `<div class="chat-highlight">${match}</div>`);
  //   // }
  
  //   // // Fallback fuzzy match logic (optional)
  //   // return masterString;
  // }

  // highlightClosestMatch(masterString: string, highlightString: string) {
  //   const normalizeQuotesAndApostrophes = (str: string) =>
  //     str
  //       .replace(/[\u2018\u2019]/g, "'") // curly apostrophes → straight
  //       .replace(/[\u201C\u201D]/g, '"') // curly quotes → straight
  //       .replace(/['"]/g, "'");         // unify all quotes to single
  
  //   const normalize = (str: string) =>
  //     normalizeQuotesAndApostrophes(str)
  //       .replace(/\s+/g, ' ')
  //       .trim()
  //       .toLowerCase();
  
  //   const normalizedHighlight = normalize(highlightString);
  
  //   const sections = masterString.split(/\n\s*\n|(?<=\.)\s+/); // better splitting
  //   let bestOriginalSection = '';
  //   let highestScore = 0;
  
  //   for (const section of sections) {
  //     const score = this.similarityScore(normalize(section), normalizedHighlight);
  //     if (score > highestScore) {
  //       highestScore = score;
  //       bestOriginalSection = section;
  //     }
  //   }
  
  //   if (highestScore > 0.8 && bestOriginalSection) {
  //     const escaped = bestOriginalSection
  //       .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') // escape regex
  //       .replace(/\s+/g, '\\s+');                 // allow flexible whitespace
  
  //     const regex = new RegExp(escaped, 'i'); // case-insensitive match
  
  //     return masterString.replace(regex, (match) =>
  //       `<div class="chat-highlight">${match}</div>`
  //     );
  //   } else {
  //     return masterString;
  //   }
  // }

  highlightClosestMatch(masterString: string, highlightString: string) {
    const normalizeQuotesAndApostrophes = (str: string) =>
      str
        .replace(/[\u2018\u2019]/g, "'") // curly apostrophes → straight
        .replace(/[\u201C\u201D]/g, '"') // curly quotes → straight
        .replace(/['"]/g, "'");         // unify all quotes to single
  
    const normalize = (str: string) =>
      normalizeQuotesAndApostrophes(str)
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
  
    const normalizedHighlight = normalize(highlightString);
  
    const sections = masterString.split(/\n\s*\n|(?<=\.)\s+/); // better splitting
    let bestOriginalSentence = '';
    let bestOriginalSection = '';
    let highestScore = 0;
  
    for (const section of sections) {
      const lines = section.split('\n');
      for (const line of lines) {
        const score = this.similarityScore(normalize(line), normalizedHighlight);
        if (score > highestScore) {
          highestScore = score;
          bestOriginalSentence = line;
          bestOriginalSection = section;
        }
      }
    }
  
    if (highestScore >= 0.7 && bestOriginalSection) {
      const escaped = bestOriginalSentence
        .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') // escape regex
        .replace(/\s+/g, '\\s+');                 // allow flexible whitespace
  
      const regex = new RegExp(escaped, 'i'); // case-insensitive match
  
      return masterString.replace(regex, (match) =>
        `<div class="chat-highlight">${match}</div>`
      );
    } else {
      return masterString;
    }
  }
  
  
  

  similarityScore(a: string, b: string): number {
    const bigrams = (str: string) => {
      const s = str.toLowerCase();
      const result = new Set<string>();
      for (let i = 0; i < s.length - 1; i++) {
        result.add(s.substring(i, i + 2));
      }
      return result;
    };
  
    const aBigrams = bigrams(a);
    const bBigrams = bigrams(b);
    const intersection = new Set([...aBigrams].filter(x => bBigrams.has(x)));
  
    return (2 * intersection.size) / (aBigrams.size + bBigrams.size);
  }

  escapeRegExp(string: any) {
    // return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return string.replace(/[.*+?^${}()|[\]\\\/\-!@#%&_=<>,:;'"`~]/g, '\\$&');
  }

  closeChatViewer() {
    this.chatMessages.set([])
    this.VariableParsedData.set("")
  }

  ngOnDestroy() {
    this.chatMessages.set([])
    this.VariableParsedData.set("")
  }
}
